import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PrivyProvider } from '@privy-io/react-auth';
import styled, { ThemeProvider, createGlobalStyle } from 'styled-components';
import { AuthProvider } from './contexts/AuthContext';

// Pages
import Home from './pages/Home';
import Console from './pages/Console';
import WalletPage from './pages/WalletPage';
import SettingsPage from './pages/SettingsPage';
import RevenueSharePage from './pages/RevenueSharePage';
import LeaderboardPage from './pages/LeaderboardPage';
import WhiteLabelPage from './pages/WhiteLabelPage';
import Holders from './pages/Holders';
import PlainHolders from './pages/PlainHolders';
import TextHolders from './pages/TextHolders';

// Theme
const theme = {
  colors: {
    primary: '#febd23',
    background: '#121212',
    text: '#FFFFFF',
    secondary: '#333333',
    accent: '#e4ae1e',
    error: '#FF5555',
    success: '#55FF7F'
  },
  fonts: {
    main: 'Consolas, Monaco, "Andale Mono", monospace'
  }
};

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body, html {
    font-family: ${props => props.theme.fonts.main};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.text};
    height: 100%;
    width: 100%;
  }

  #root {
    height: 100vh;
    width: 100vw;
  }

  button {
    cursor: pointer;
  }
`;

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <PrivyProvider
        appId="cm9scs75g00itjp0n1mh3dxld"
        config={{
          appearance: {
            theme: 'dark',
            accentColor: '#febd23',
          },
          loginMethods: ['twitter']
        }}
      >
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/console" element={<Console />} />
              <Route path="/wallet" element={<WalletPage />} />
              <Route path="/revenue" element={<RevenueSharePage />} />
              <Route path="/leaderboard" element={<LeaderboardPage />} />
              <Route path="/whitelabel" element={<WhiteLabelPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/holders-analytics" element={<Holders />} />
              <Route path="/holders-plain" element={<PlainHolders />} />
              <Route path="/holders-text" element={<TextHolders />} />
            </Routes>
          </Router>
        </AuthProvider>
      </PrivyProvider>
    </ThemeProvider>
  );
}

export default App;
